<template>
  <div class="imageUploaderMain" :style="cssProps">
    <div style="position: relative: height: 0px;">
      <FileUploaderProgress v-if="imageUploader.isUploadInterfaceVisible"
                            :file-objs="imageUploader.files"
                            :is-mime="false"
                            @complete="uploadCompleted"
      />
    </div>
    <div class="topBar">
      <div class="closeBtn" @click="closeImageUploader">
        <img src="@/assets/images/close2.png">
      </div>
      <div>Ön izleme</div>
    </div>
    <div class="preview">
      <img :src="activePreviewSrc">
    </div>
    <div class="inputBar">
      <input placeholder="Başlık ekle..." v-model="imageUploader.bodyText">
    </div>

    <div class="thumbsRow">
      <div style="position:relative" v-for="(imageFileObj, index) in imageUploader.files"
           :key="index + conversationID + 'PRTU' + imageFileObj.file.name"
      >
        <FileImage class="thumbImage" :class="{ selectedThumb: selectedImageIndex === index }"
                   :file="imageFileObj.file"
                   :is-mime="false"
                   @click.native="selectThumb(index)"
        />
        <div class="removeImageFromList" @click="removeImageFromList(index)">
          <img src="@/assets/images/clearbtn.png">
        </div>
      </div>
      <input style="display: none;" ref="imageFileSelector" @input="imageFilesSelected" type="file"
             accept="image/*"
             multiple
      >
      <div class="addNewFileButton" @click="openFileDialog">
        <img src="@/assets/images/plus.png">
        <div class="">
          Dosya Ekle
        </div>
      </div>
    </div>

    <div class="sendBtnRow">
      <div class="sendBtn" @click="startUploadingFiles">
        <img src="@/assets/images/upload_white.png">
      </div>
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'
import FileUploaderProgress from '../FileUploaderProgress.vue'
import FileImage from './FileImage.vue'
require('@/security.js')
var moment = require('moment')

export default {
  mixins: [messageMixin],

  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.previewPage.topBarColor,
        '--bottomBorderColor': this.$config.theme.default.previewPage.bottomBorderColor,
        '--buttonColor': this.$config.theme.default.previewPage.buttonColor
      }
    }
  },
  props: {
    imageUploader: {
      type: Object,
      default: function () {
        return {}
      }
    },
    conversationID: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      selectedImageIndex: 0,
      activePreviewSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg=='
    }
  },

  methods: {
    selectThumb (index) {
      this.selectedImageIndex = index
    },

    closeImageUploader () {
      this.$store.commit('setActiveConversationImageUploaderFiles', [])
      this.$store.commit('setActiveConversationImageUploaderVisibility', false)
    },

    openFileDialog () {
      this.$refs.imageFileSelector.click()
    },

    imageFilesSelected () {
      let inputFiles = []

      for (let file of this.$refs.imageFileSelector.files) {
        let mod = JSON.parse(
          JSON.stringify(this.$store.state.message.uploadFileModel)
        )
        mod.file = file
        mod.processId = this.$uuid.v4()
        mod.uploadUrl = process.env.VUE_APP_UPLOADURL
        inputFiles.push(mod)
      }

      this.$store.commit(
        'appendActiveConversationImageUploaderFiles',
        inputFiles
      )

      this.$refs.imageFileSelector.value = ''
    },

    removeImageFromList (index) {
      this.imageUploader.files.splice(index, 1)
      this.$store.commit(
        'setActiveConversationImageUploaderFiles',
        this.imageUploader.files
      )
      this.selectedImageIndex = 0
      this.loadImageForPreview(0)
    },

    loadImageForPreview (index) {
      var vm = this
      if (this.imageUploader.files.length === 0) {
        vm.activePreviewSrc =
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg=='
        return
      }
      if (this.imageUploader.files[index].file) {
        var reader = new FileReader()
        reader.onload = function (e) {
          vm.activePreviewSrc = e.target.result
        }

        reader.readAsDataURL(vm.imageUploader.files[index].file)
      }
    },

    startUploadingFiles () {
      this.imageUploader.isUploadInterfaceVisible = true
    },

    uploadCompleted () {
      let urls = this.imageUploader.files.map(x => x.resultURL)
      this.imageUploader.isVisible = false
      this.imageUploader.isUploadInterfaceVisible = false
      this.addImageMessageFromMe(urls)
    },

    addImageMessageFromMe (imageUrls) {
      var newMsg = JSON.parse(
        JSON.stringify(
          this.$store.state.conversation.activeConversation.newMessage
        )
      )
      newMsg.MessageID = this.$uuid.v4()
      newMsg.CreateDate =
          moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      newMsg.UpdateDate =
          moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      newMsg.From = this.$store.state.session.user.UserID
      if (
        this.$store.state.conversation.activeConversation.isGroupConversation ===
          true
      ) {
        newMsg.To = this.$store.state.conversation.activeConversation.GroupID
        newMsg.ConversationID = ''
        newMsg.isGroup = true
        newMsg.ConversationType = 1
      } else if (this.$store.state.conversation.activeConversation.isChannelConversation === true) {
        newMsg.To = this.$store.state.conversation.activeConversation.ChannelID
        newMsg.ConversationID = ''
        newMsg.isGroup = false
        newMsg.ConversationType = 2
      } else {
        newMsg.To = this.$store.state.conversation.activeConversation.ContactID
        newMsg.ConversationID = this.$store.state.conversation.activeConversation.ConversationID
        newMsg.ConversationType = 0
      }
      newMsg.MessageType = 1
      newMsg.MediaURLs = imageUrls
      newMsg.Body = this.imageUploader.bodyText
      newMsg.DeleteStatus = 0

      if (this.$store.state.ien) {
        this.$set(newMsg, 'mv', 2)// encryption update
        this.em(newMsg)
      }

      this.$store.dispatch('appendMessages', [newMsg])
      this.$store.dispatch('clearActiveNewMessage')

      this.sendMessage(newMsg)

      this.imageUploader.bodyText = ''
    }
  },
  components: {
    FileImage,
    FileUploaderProgress
  },

  watch: {
    selectedImageIndex: {
      // eslint-disable-next-line
        handler: function (val, oldVal) {
        this.loadImageForPreview(val)
      },
      deep: false
    },

    conversationID: {
      // eslint-disable-next-line
        handler: function (val, oldVal) {
        this.loadImageForPreview(0)
      },
      deep: false
    }
  },

  mounted () {
    this.loadImageForPreview(0)
  }
}

</script>

<style scoped>
  .imageUploaderMain {
    width: 100%;
    height: calc(100% - 60px);
    position: absolute;
    top: 60px;
    left: 0px;
    background-color: white;
    z-index: 900000;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .topBar {
    background-color: var(--topBarColor);
    padding: 10px;
    color: white;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .closeBtn,
  .closeBtn>img {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }

  .closeBtn {
    margin-right: 10px;
  }

  .preview {
    flex-grow: 1;
    display: flex;
    align-items: stretch;
    padding: 50px;
    justify-content: center;
  }

  .preview>img {
    object-fit: contain;
    max-width: 70%;
    max-height: 500px;
  }

  .inputBar {
    padding: 10px;
    background-color: rgb(241, 241, 241);
    height: 80px;
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inputBar>input {
    height: 30px;
    width: 70%;
    border: none;
    background-color: rgba(0, 0, 0, 0);
    border-bottom: 1px solid var(--bottomBorderColor);
    font-size: 14px;
    font-weight: 300;
  }

  .inputBar>input:focus {
    outline: none;
  }

  .thumbsRow {
    min-height: 100px;
    background-color: #d1d1d1;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-shrink: 0;
    overflow-x: scroll;
  }

  .thumbsRow::-webkit-scrollbar {
    height: 3px;
  }

  .thumbsRow::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }

  .thumbImage {
    width: 100px;
    height: 100px;
    margin: 10px;
    margin-left: 0px;
    border: 0px solid white;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .selectedThumb {
    border: 4px solid white;
    width: 92px;
    height: 92px;
  }

  .addNewFileButton {
    width: 100px;
    height: 100px;
    margin: 10px;
    margin-left: 0px;
    background-color: white;
    cursor: pointer;
    font-weight: 700;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }

  .addNewFileButton>img {
    width: 20px;
    height: 20px;
    margin-bottom: 15px;
  }

  .sendBtnRow {
    height: 0px;
    display: flex;
    position: relative;
  }

  .sendBtn {
    background-color: var(--buttonColor);
    position: absolute;
    top: -145px;
    right: 30px;
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
  }

  .sendBtn>img {
    width: 25px;
    height: 25px;
  }

  .removeImageFromList {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transition: all 0.3s ease;
  }

  .removeImageFromList>img {
    width: 13px;
    height: 13px;
  }

  .thumbImage:hover+.removeImageFromList {
    opacity: 1;
  }

  .removeImageFromList:hover {
    opacity: 1;
  }

</style>
